// let priceDates = {
//     high: 50,
//     medium: 40,
//     low: 10
// };

export function addAttributeId(element, dateType) {
  element.setAttribute("data-id", dateType.id);
}

export function addAttributePrice(element, dateType, loading, extraPercentage) {
  if(loading || dateType.price == 0) element.setAttribute("data-price", "");
  else{
    element.setAttribute("data-price", new Intl.NumberFormat('es-ES').format(dateType.price) + "€");

    //Only show promo prices on ebm
    if(window.appConfig == 'ebm' && extraPercentage > 0){
      const num = Number(dateType.price.replace(/[^0-9.-]+/g,""));

      const oldPrice = Math.round(num / (1 - extraPercentage / 100));

      element.setAttribute("data-old-price", new Intl.NumberFormat('es-ES').format(oldPrice) + "€");
    }
  }

  element.classList.add(dateType.type + "-before");
}

export function disableCell(element) {
  element.classList.add("cell");
  element.classList.add("disabled");
  return element;
}

export function clearCalendar() {
  document.getElementById("calendar-body-1").innerHTML = "";
  document.getElementById("calendar-body-2").innerHTML = "";
}
